import { createModule } from '../../createModule';
export const createAccountAPI = createModule(({ http }) => ({
    saveLightsailIP: async () => {
        const res = await http.post(`/v2/account/ip/whitelist/lightsail`);
        return res;
    },
    getUserDetails: async () => {
        const res = await http.get('/v2/account/details');
        return res;
    },
}));
